import { Link, Route, Routes } from 'react-router-dom';
import './App.css';
import Main from './pages/Main';
import Header from './components/Header';
import Footer from './components/Footer';
import TransferPopup from './pages/TransferPopup';
import ExtraForBooking from './pages/ExtraForBooking';
import Cart from './pages/Cart';
import ParkingPopup from './pages/ParkingPopup';
import LoungePopup from './pages/LoungePopup';
import { Box, Button, Container, Paper } from '@mui/material';
import Login from './pages/Login';
import MyBooking from './pages/MyBooking';
import ShowMyBooking from './pages/ShowMyBooking';
import MyCart from './pages/MyCart';
import Contact from './pages/Contact';
import FastTrackPopup from './pages/FastTrackPopup';
import ForgetPasswordPage from './pages/ForgetPasswordPage';
import StaticPage from './pages/StaticPage';
import ActivatePage from './components/authentication/ActivatePage';
import PasswordResetFinishPage from './components/authentication/PasswordResetFinishPage';
import ProtectedRoute from './components/ProtectedRoute';

const NextToCart = () => (<Box sx={{ bgcolor: 'rgba(0,0,0, .2)' }} >
  <Container sx={{ justifyContent: 'center', alignContent: 'center', alignItems: 'center', display: 'flex' }} >
    <Box sx={{ width: '60%', py: 3, textAlign: 'right' }}>
      <Link to="/cart">
        <Button variant='contained'>
          Next
        </Button>
      </Link>
    </Box>
  </Container>
</Box>);

function App() {
  return (
    <>

      <Header />
      <Routes>
        <Route path="/" element={<Main />} />
        <Route path="/transfer" element={
          <ProtectedRoute>
            <>
              <TransferPopup />
              <ParkingPopup />
              <LoungePopup />
              <FastTrackPopup />
              <NextToCart />
            </>
          </ProtectedRoute>
        } />
        <Route path="/parking" element={
          <ProtectedRoute>
            <>
              <ParkingPopup />
              <LoungePopup />
              <TransferPopup />
              <FastTrackPopup />
              <NextToCart />

            </>
          </ProtectedRoute>
        } />
        <Route path="/lounge" element={
          <ProtectedRoute>
            <>
              <LoungePopup />
              <TransferPopup />
              <ParkingPopup />
              <FastTrackPopup />
              <NextToCart />
            </>
          </ProtectedRoute>
        } />
        <Route path="/fast-track" element={
          <ProtectedRoute>
            <>
              <FastTrackPopup />
              <LoungePopup />
              <TransferPopup />
              <ParkingPopup />
              <NextToCart />
            </>
          </ProtectedRoute>
        } />
        <Route path="/extra" element={<ExtraForBooking />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/about-us" element={<StaticPage slug="about-us" />} />
        <Route path="/rewards" element={<StaticPage slug="rewards" />} />
        <Route path="/work-with-us" element={<StaticPage slug="work-with-us" />} />
        <Route path="/meet-the-team" element={<StaticPage slug="meet-the-team" />} />
        <Route path="/legal" element={<StaticPage slug="legal" />} />
        <Route path="/privacy-policy" element={<StaticPage slug="privacy-policy" />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgetPasswordPage />} />
        <Route path="/activate" element={<ActivatePage />} />
        <Route path="/reset/finish" element={<PasswordResetFinishPage />} />

        <Route path="/my-booking" element={<MyBooking />} />
        <Route path="/my-booking/:orderId" element={<ShowMyBooking />} />

        <Route path="/my-cart" element={<MyCart />} />

      </Routes>
      <Footer />

    </>
  );
}

export default App;
